(() => {
  const initialize = () => {
    const header = document.getElementById('SiteHeader');
    if (!header || header.dataset.eoInitialized) return;
    header.dataset.eoInitialized = 'true';
    const items = [...header.querySelectorAll('.eo-nav__item')];
    const branches = [...header.querySelectorAll('.eo-nav__branch')];
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    const desktop = matchMedia('(min-width: 1200px)');
    const timers = new Map();
    const clear = item => {
      const timer = timers.get(item);
      if (timer) clearTimeout(timer);
      timers.delete(item);
    };
    const fit = () => {
      const bottom = header.getBoundingClientRect().bottom;
      const viewportBottom = window.visualViewport ? window.visualViewport.height + window.visualViewport.offsetTop : window.innerHeight;
      header.style.setProperty('--eo-nav-available', `${Math.max(0, viewportBottom - bottom - 12)}px`);
    };
    const sync = branch => branch.querySelector('summary').setAttribute('aria-expanded', String(branch.open));
    const close = branch => {
      clear(branch.closest('.eo-nav__item'));
      branch.open = false;
      sync(branch);
    };
    const open = branch => {
      if (!desktop.matches) return;
      branches.forEach(other => { if (other !== branch) close(other); });
      fit();
      branch.open = true;
      sync(branch);
    };
    items.forEach(item => {
      const branch = item.querySelector('.eo-nav__branch');
      if (!branch) return;
      const summary = branch.querySelector('summary');
      const panel = branch.querySelector('.eo-nav__panel');
      sync(branch);
      branch.addEventListener('toggle', () => {
        if (branch.open) {
          fit();
          branches.forEach(other => { if (other !== branch) close(other); });
        }
        sync(branch);
      });
      item.addEventListener('pointerenter', event => {
        if (!hover.matches || event.pointerType === 'touch' || item.closest('[data-eo-nav]').dataset.hoverEnabled !== 'true') return;
        clear(item);
        timers.set(item, setTimeout(() => open(branch), 350));
      });
      item.addEventListener('pointerleave', () => {
        clear(item);
        if (!panel.contains(document.activeElement)) timers.set(item, setTimeout(() => close(branch), 250));
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) close(branch);
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape' && branch.open) {
          event.preventDefault();
          event.stopPropagation();
          close(branch);
          summary.focus();
        }
        if (event.key === 'ArrowDown' && (event.target === summary || event.target === item.firstElementChild)) {
          event.preventDefault();
          open(branch);
          panel.querySelector('a')?.focus();
        }
      });
      item.addEventListener('keyup', event => {
        if (event.key === 'Escape') event.stopPropagation();
      });
      summary.addEventListener('click', () => clear(item));
    });
    document.addEventListener('pointerdown', event => {
      if (!event.target.closest('.eo-nav__item')) branches.forEach(close);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') branches.forEach(close);
    });
    document.querySelectorAll('.js-drawer-open-nav, .js-search-header, .js-drawer-open-cart').forEach(control => control.addEventListener('click', () => branches.forEach(close)));
    window.addEventListener('resize', () => {
      if (!desktop.matches) branches.forEach(close);
      fit();
    }, {passive: true});
    window.addEventListener('scroll', () => {
      if (branches.some(branch => branch.open)) requestAnimationFrame(fit);
    }, {passive: true});
    window.visualViewport?.addEventListener('resize', fit, {passive: true});
    new ResizeObserver(fit).observe(header);
    fit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
